import type { Pretty, PrettyPart } from './types';
import {
    isIterable,
    elementsSatisfy,
} from '@precon-tools-suite-by-shared/js-utils';

export function isPrettyPart(x: unknown): x is PrettyPart {
    if (
        !x ||
        typeof x !== 'object' ||
        !('specifier' in x) ||
        typeof x.specifier !== 'string'
    )
        return false;
    const i = ['c', 'o', 'O', 's', 'i', 'd', 'f'].indexOf(x.specifier);
    return i == 0 || (i > 0 && 'value' in x);
}

export const isPretty = (obj: unknown): obj is Pretty =>
    obj !== null &&
    typeof obj === 'object' &&
    '__pretty' in obj &&
    typeof obj.__pretty === 'function';

export const isPrettyPartIterable = (x: unknown): x is Iterable<PrettyPart> => {
    return (
        isIterable(x) &&
        (typeof x === 'object' || typeof x === 'function') &&
        elementsSatisfy(x, isPrettyPart)
    );
};
